/* BraidingFest theme scripts */
(function () {
  'use strict';
  var BF = window.BF || {};
  var proxy = BF.proxy || '/apps/braidingfest';

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Only allow same-origin paths or https URLs from the app.
  function safeHref(v) {
    var s = String(v || '');
    return /^\/(?!\/)/.test(s) || /^https:\/\//.test(s) ? s : '#';
  }
  function money(n) {
    n = Number(n || 0);
    return n === 0 ? 'Free' : '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  /* Mobile menu */
  function initMenu() {
    var btn = document.querySelector('[data-menu-toggle]');
    var nav = document.getElementById('MobileNav');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(open));
      nav.setAttribute('data-open', String(open));
      btn.querySelector('[data-icon-open]').classList.toggle('is-hidden', open);
      btn.querySelector('[data-icon-close]').classList.toggle('is-hidden', !open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { btn.click(); btn.focus(); }
    });
  }

  /* "N days away" counters, computed in Pacific time */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var d = el.getAttribute('data-countdown');
      if (!/^\d{4}-\d{2}-\d{2}$/.test(d)) return;
      var target = new Date(d + 'T12:00:00-08:00');
      var days = Math.ceil((target - Date.now()) / 86400000);
      if (days < 0) return;
      var out = el.querySelector('[data-days]');
      if (out) out.textContent = days;
      el.hidden = false;
    });
  }

  /* Reveal on scroll */
  function initReveal() {
    var items = document.querySelectorAll('.fade-up');
    if (!('IntersectionObserver' in window)) { items.forEach(function (i) { i.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (i) { io.observe(i); });
  }

  /* Cart count + add to cart without leaving the page */
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-hidden', !n);
    });
  }
  function initAddToCart() {
    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var btn = form.querySelector('[type=submit]');
        var status = form.querySelector('[data-cart-status]');
        btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'Could not add to cart'); return d; }); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            setCartCount(cart.item_count);
            if (status) status.innerHTML = 'Added to your cart. <a href="/cart">View cart</a>';
          })
          .catch(function (err) { if (status) status.textContent = err.message; })
          .finally(function () { btn.disabled = false; });
      });
    });
  }

  /* Product page: variants, gallery, quantity */
  function initProduct() {
    var root = document.querySelector('[data-product]');
    if (!root) return;
    var dataEl = root.querySelector('[data-product-json]');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var idInput = root.querySelector('input[name=id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var addBtn = root.querySelector('[data-add]');
    function update() {
      if (!product) return;
      var chosen = Array.prototype.map.call(root.querySelectorAll('[data-option]'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      priceEl.textContent = v.price_formatted;
      if (compareEl) { compareEl.textContent = v.compare_formatted || ''; compareEl.hidden = !v.compare_formatted; }
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      if (v.image) swap(v.image);
    }
    root.querySelectorAll('[data-option] input').forEach(function (i) { i.addEventListener('change', update); });
    var main = root.querySelector('.product__media img');
    function swap(src) { if (main) { main.removeAttribute('srcset'); main.src = src; } }
    root.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        swap(b.getAttribute('data-thumb'));
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', String(x === b)); });
      });
    });
    root.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.getAttribute('data-step')));
          input.value = n;
        });
      });
    });
  }

  /* Live data from the BraidingFest app (directory, votes, events) */
  var homeData = null;
  function getHome() {
    if (homeData) return homeData;
    homeData = fetch(proxy + '/api/home', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('unavailable'); return r.json(); });
    return homeData;
  }

  function initLeaderboard() {
    var box = document.querySelector('[data-leaderboard]');
    if (!box) return;
    getHome().then(function (d) {
      var lb = d && d.leaderboard;
      if (!lb || !lb.categories || !lb.categories.length) return;
      var cats = box.querySelector('[data-lb-cats]');
      var rows = box.querySelector('[data-lb-rows]');
      var title = box.querySelector('[data-lb-title]');
      var meta = box.querySelector('[data-lb-meta]');
      function show(i) {
        var c = lb.categories[i];
        cats.querySelectorAll('button').forEach(function (b, j) { b.setAttribute('aria-pressed', String(j === i)); });
        title.textContent = c.name;
        meta.textContent = (lb.region ? lb.region + ' · ' : '') + Number(c.total || 0).toLocaleString() + ' votes';
        var max = c.rows.length ? c.rows[0].votes || 1 : 1;
        rows.innerHTML = c.rows.length ? c.rows.map(function (r, k) {
          return '<li><span class="rank rank--' + (k + 1) + '">' + (k + 1) + '</span>' +
            (r.photo ? '<img class="board__avatar" src="' + esc(r.photo) + '" alt="" loading="lazy">' : '<span class="board__avatar"></span>') +
            '<div style="flex:1;min-width:0"><div style="display:flex;justify-content:space-between;gap:8px"><a href="' + esc(safeHref(r.url)) + '" style="font-weight:700;color:var(--ink);text-decoration:none">' + esc(r.name) + '</a><strong>' + Number(r.votes || 0).toLocaleString() + '</strong></div>' +
            '<div class="mute-ink" style="font-size:13px">' + esc(r.city) + (r.licensed ? ' · Licensed' : '') + '</div>' +
            '<div class="bar"><span style="width:' + Math.round((r.votes || 0) / max * 100) + '%"></span></div></div>' +
            (lb.open ? '<a class="btn btn--ink btn--sm" href="' + esc(safeHref(r.voteUrl)) + '">Vote</a>' : '') + '</li>';
        }).join('') : '<li class="mute-ink" style="border:0">Nominees appear here once they’re approved.</li>';
      }
      cats.innerHTML = lb.categories.map(function (c, i) {
        return '<button class="chip" type="button" aria-pressed="false" data-i="' + i + '">' + esc(c.name) + '</button>';
      }).join('');
      cats.addEventListener('click', function (e) { var b = e.target.closest('button[data-i]'); if (b) show(Number(b.getAttribute('data-i'))); });
      show(0);
    }).catch(function () {});
  }

  function initTopStylists() {
    var sec = document.querySelector('[data-top-stylists]');
    if (!sec) return;
    var count = Number(sec.getAttribute('data-count')) || 4;
    getHome().then(function (d) {
      var list = (d && d.stylists || []).slice(0, count);
      if (!list.length) return;
      sec.querySelector('[data-top-grid]').innerHTML = list.map(function (s) {
        var badges = [];
        if (s.featured) badges.push('<span class="pill pill--pink">Featured</span>');
        if (s.award) badges.push('<span class="pill pill--yel">' + esc(s.award) + '</span>');
        badges.push(s.licensed ? '<span class="pill pill--lic">Licensed</span>' : '<span class="pill pill--spec">Specialist</span>');
        return '<a class="card" href="' + esc(safeHref(s.url)) + '"><div class="card__media">' +
          (s.photo ? '<img src="' + esc(s.photo) + '" alt="' + esc(s.name) + ' work" loading="lazy">' : '') + '</div>' +
          '<div class="card__body"><span class="card__title">' + esc(s.name) + '</span>' +
          '<span class="mute-ink" style="font-size:14px;font-weight:600">' + esc(s.role) + (s.city ? ' · ' + esc(s.city) : '') + '</span>' +
          '<span style="font-size:14px">' + (s.rating ? '<span style="color:#F5A400">★</span> <strong>' + Number(s.rating).toFixed(1) + '</strong> <span class="mute-ink">(' + Number(s.reviews || 0) + ')</span>' : '<span class="mute-ink">New</span>') + (s.priceFrom ? ' · from $' + Number(s.priceFrom) : '') + '</span>' +
          '<span class="row" style="gap:6px">' + badges.join('') + '</span></div></a>';
      }).join('');
      sec.hidden = false;
    }).catch(function () {});
  }

  function initEvents() {
    var sec = document.querySelector('[data-events-preview]');
    if (!sec) return;
    getHome().then(function (d) {
      var list = (d && d.events || []).slice(0, 4);
      if (!list.length) return;
      var fmt = function (iso, opts) { return new Intl.DateTimeFormat('en-US', Object.assign({ timeZone: 'America/Los_Angeles' }, opts)).format(new Date(iso)); };
      sec.querySelector('[data-events-grid]').innerHTML = list.map(function (e) {
        return '<a class="event-row" href="' + esc(safeHref(e.url)) + '"><div class="event-row__date"><span style="font-weight:700;font-size:14px">' + fmt(e.startsAt, { weekday: 'short' }) + '</span><strong>' + fmt(e.startsAt, { month: 'short', day: 'numeric' }) + '</strong></div>' +
          '<div class="event-row__body"><span class="pill pill--spec" style="align-self:flex-start">' + esc(e.kind) + '</span><span class="card__title" style="font-size:22px">' + esc(e.title) + '</span>' +
          '<span class="mute-ink" style="font-size:14px">' + fmt(e.startsAt, { hour: 'numeric', minute: '2-digit' }) + ' · ' + esc(e.isVirtual ? 'Online' : e.venue || '') + ' · ' + money(e.price) + '</span></div></a>';
      }).join('');
      sec.hidden = false;
    }).catch(function () {});
  }


  /* ── The Race homepage ── */
  var RANK_COLORS = ['#FF6A13', '#FF1FA8', '#FFFFFF', 'rgba(255,255,255,.45)', 'rgba(255,255,255,.3)'];
  var pt = function (iso, opts) { return new Intl.DateTimeFormat('en-US', Object.assign({ timeZone: 'America/Los_Angeles' }, opts)).format(new Date(iso)); };

  function initTicker() {
    var run = document.querySelector('[data-ticker-run]');
    if (!run) return;
    getHome().then(function (d) {
      var t = (d && d.ticker) || [];
      if (t.length < 3) return;
      var items = t.map(function (v) {
        return '<span><b aria-hidden="true">&#9650;</b> ' + esc(v.name) + ' +1 · ' + esc(v.category) + (v.city ? ' · ' + esc(v.city) : '') + '</span>';
      });
      if (d.votesToday) items.push('<span>' + Number(d.votesToday).toLocaleString() + ' votes today</span>');
      var html = items.join('');
      run.innerHTML = html + html;
    }).catch(function () {});
  }

  function initRaceCount() {
    var el = document.querySelector('[data-race-count]');
    if (!el) return;
    var d = el.getAttribute('data-race-count');
    if (!/^\d{4}-\d{2}-\d{2}$/.test(d)) return;
    // 11:59 PM Pacific on the closing day (PST in November).
    var end = new Date(d + 'T23:59:00-08:00');
    function tick() {
      var ms = end - Date.now();
      if (ms <= 0) { el.hidden = true; return; }
      el.querySelector('[data-d]').textContent = Math.floor(ms / 86400000);
      el.querySelector('[data-h]').textContent = Math.floor(ms / 3600000) % 24;
      el.querySelector('[data-m]').textContent = Math.floor(ms / 60000) % 60;
      el.hidden = false;
    }
    tick();
    setInterval(tick, 30000);
  }

  function initStandings() {
    var box = document.querySelector('[data-standings]');
    if (!box) return;
    getHome().then(function (d) {
      var lb = d && d.leaderboard;
      if (!lb || !lb.categories || !lb.categories.length) return;
      var tabs = box.querySelector('[data-st-tabs]');
      var rows = box.querySelector('[data-st-rows]');
      var cats = lb.categories.slice(0, 6);
      function show(i) {
        var c = cats[i];
        tabs.querySelectorAll('button').forEach(function (b, j) { b.setAttribute('aria-pressed', String(j === i)); });
        var max = c.rows.length ? c.rows[0].votes || 1 : 1;
        rows.innerHTML = c.rows.slice(0, 4).map(function (r, k) {
          var col = RANK_COLORS[k] || RANK_COLORS[4];
          return '<li><span class="r-rank" style="color:' + col + '">' + (k + 1) + '</span>' +
            (r.photo ? '<img src="' + esc(r.photo) + '" alt="" loading="lazy" width="60" height="60">' : '<span class="r-ph"></span>') +
            '<div style="min-width:0"><div style="display:flex;justify-content:space-between;gap:10px"><a class="r-name" href="' + esc(safeHref(r.url)) + '">' + esc(r.name) + '</a><span class="r-votes">' + Number(r.votes || 0).toLocaleString() + '</span></div>' +
            '<div class="r-bar"><span style="width:' + Math.max(4, Math.round((r.votes || 0) / max * 100)) + '%;background:' + col + '"></span></div></div>' +
            (lb.open ? '<a class="r-vote" href="' + esc(safeHref(r.voteUrl)) + '" aria-label="Vote for ' + esc(r.name) + '">Vote</a>' : '<span></span>') + '</li>';
        }).join('');
      }
      tabs.innerHTML = cats.map(function (c, i) { return '<button class="r-tab" type="button" aria-pressed="false" data-i="' + i + '">' + esc(c.name) + '</button>'; }).join('');
      tabs.addEventListener('click', function (e) { var b = e.target.closest('button[data-i]'); if (b) show(Number(b.getAttribute('data-i'))); });
      show(0);
    }).catch(function () {});
  }

  function initCities() {
    var sec = document.querySelector('[data-cities]');
    if (!sec) return;
    var tints = ['#FF6A13', '#FF1FA8', '#3A1466'];
    getHome().then(function (d) {
      var list = (d && d.cities) || [];
      if (list.length < 4) return;
      list = list.slice(0, list.length >= 8 ? 8 : 4);
      sec.querySelector('[data-cities-grid]').innerHTML = list.map(function (c, i) {
        return '<a class="r-city" href="' + esc(safeHref(c.url)) + '" style="background:' + tints[i % 3] + '">' +
          (c.photo ? '<img src="' + esc(c.photo) + '" alt="" loading="lazy">' : '') +
          '<span class="r-city__txt"><small>' + (c.votes ? 'Leading in' : 'Top pick in') + '</small><strong>' + esc(c.city) + '</strong><span>' + esc(c.name) + '</span></span></a>';
      }).join('');
      sec.hidden = false;
    }).catch(function () {});
  }

  function initFind() {
    var sec = document.querySelector('[data-find]');
    if (!sec) return;
    var count = Number(sec.getAttribute('data-count')) || 4;
    getHome().then(function (d) {
      var list = ((d && d.stylists) || []).slice(0, count);
      if (!list.length) return;
      var grid = sec.querySelector('[data-find-grid]');
      grid.innerHTML = list.map(function (s) {
        var badge = s.rank ? '<span class="r-badge">#' + s.rank.rank + ' in ' + esc(s.rank.category) + '</span>' : (s.featured ? '<span class="r-badge r-badge--feat">Featured</span>' : '');
        var meta = [s.role, s.city].filter(Boolean).map(esc).join(' · ');
        var rating = s.rating ? '★ ' + Number(s.rating).toFixed(1) + ' (' + Number(s.reviews || 0) + ')' : 'New';
        return '<a class="r-card" href="' + esc(safeHref(s.url)) + '"><div class="r-card__media">' +
          (s.photo ? '<img src="' + esc(s.photo) + '" alt="' + esc(s.name) + ' work" loading="lazy">' : '') + badge + '</div>' +
          '<div class="r-card__body"><b>' + esc(s.name) + '</b><small>' + meta + '</small>' +
          '<div class="r-card__foot"><span>' + (s.priceFrom ? 'from $' + Number(s.priceFrom) : rating) + '</span><em>Book &rarr;</em></div></div></a>';
      }).join('');
      grid.hidden = false;
    }).catch(function () {});
  }

  function initRaceEvents() {
    var sec = document.querySelector('[data-race-events]');
    if (!sec) return;
    var skip = sec.getAttribute('data-skip-featured') === 'true';
    var tagColors = ['#FF6A13', '#FF1FA8', '#FFFFFF'];
    getHome().then(function (d) {
      var list = ((d && d.events) || []).filter(function (e) { return !(skip && e.featured); }).slice(0, 3);
      if (!list.length) return;
      sec.querySelector('[data-race-events-list]').innerHTML = list.map(function (e, i) {
        var tag = e.price === 0 ? 'Free' : (e.kind || 'Event');
        return '<a class="r-ev" href="' + esc(safeHref(e.url)) + '"><span class="r-ev__date"><small>' + pt(e.startsAt, { month: 'short' }) + '</small><strong>' + pt(e.startsAt, { day: 'numeric' }) + '</strong></span>' +
          '<span><b>' + esc(e.title) + '</b><span class="r-ev__meta">' + esc(e.isVirtual ? 'Online' : (e.venue || '')) + ' · ' + pt(e.startsAt, { hour: 'numeric', minute: '2-digit' }) + '</span></span>' +
          '<span class="r-tag" style="color:' + tagColors[i % 3] + '">' + esc(tag) + '</span></a>';
      }).join('');
      sec.hidden = false;
    }).catch(function () {});
  }

  function initFinaleLink() {
    var a = document.querySelector('[data-finale-auto]');
    if (!a) return;
    getHome().then(function (d) {
      var ev = ((d && d.events) || []).filter(function (e) { return e.featured; })[0];
      if (ev) a.href = safeHref(ev.url);
    }).catch(function () {});
  }

  function initCourses() {
    var box = document.querySelector('[data-courses]');
    if (!box) return;
    getHome().then(function (d) {
      var list = (d && d.courses) || [];
      if (!list.length) return;
      box.innerHTML = list.map(function (c) {
        var label = c.kind === 'CERTIFICATION' ? 'Certification' : (c.price === 0 ? 'Free course' : 'Course');
        var meta = [c.lessons + (c.lessons === 1 ? ' lesson' : ' lessons'), c.hasQuiz ? 'quiz and certificate' : '', c.price === 0 ? 'free' : (c.included ? 'included with membership' : money(c.price))].filter(Boolean).join(' · ');
        return '<a class="r-course" href="' + esc(safeHref(c.url)) + '"><span><small>' + label + '</small><b>' + esc(c.title) + '</b><span class="r-course__meta">' + esc(meta) + '</span></span><span aria-hidden="true">&rarr;</span></a>';
      }).join('');
    }).catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initCountdowns();
    initReveal();
    initAddToCart();
    initProduct();
    initLeaderboard();
    initTopStylists();
    initEvents();
    initTicker();
    initRaceCount();
    initStandings();
    initCities();
    initFind();
    initRaceEvents();
    initCourses();
    initFinaleLink();
  });
})();
